<div class="media-selection-row">
  @if (showGripHandle) {
    <rv-sortable-handle></rv-sortable-handle>
  }
  <div
    class="media-selection-thumbnail"
    [class.default-thumbnail]="shouldUseDefaultImageThumbnail()"
  >
    @if (entry.exists && hasServerThumbnail()) {
      <img
        [src]="getThumbnailUrl()"
        [ngClass]="{ 'img-contain': isDefaultThumbnail() }"
        [attr.alt]="
          isDefaultThumbnail() ? '' : 'Thumbnail for ' + getFileName()
        "
      />
    } @else if (fileType === 'image' && entry.exists && getImagePreviewUrl()) {
      <img
        class="media-link-preview"
        [src]="getImagePreviewUrl()"
        alt="Preview for {{ getFileName() }}"
        (error)="onImagePreviewError()"
      />
    } @else if (fileType === 'image' && entry.exists) {
      <img class="img-contain" [src]="defaultImageThumbnail" alt="" />
    } @else if (fileType === 'video' && entry.exists && getVideoPreviewUrl()) {
      <video preload="metadata" muted aria-hidden="true">
        <source [src]="getVideoPreviewUrl()" />
      </video>
      <mat-icon
        svgIcon="play-circle-filled"
        class="media-selection-play"
      ></mat-icon>
    } @else {
      <div class="media-selection-placeholder">
        @if (!entry.exists) {
          <streamline-icon
            width="30"
            height="30"
            aria-hidden="true"
            name="forbidden"
          ></streamline-icon>
        } @else if (fileType === 'video') {
          <mat-icon
            svgIcon="play-circle-filled"
            class="media-selection-play"
          ></mat-icon>
        }
      </div>
    }
  </div>
  <div
    class="media-selection-details"
    [ngClass]="{ 'is-error': !entry.exists }"
  >
    <div class="media-selection-text">
      <div class="media-selection-name" title="{{ getStoragePath() }}">
        {{ getFileName() }}
      </div>
      <div class="media-selection-subtitle">
        {{ getFileTypeLabel() }}
      </div>
      <div class="media-selection-error" [hidden]="entry.exists">
        Your {{ fileType }} has been deleted, renamed, or moved.
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="media-selection-remove"
      title="Delete"
      aria-label="Delete"
      (click)="removeFileFromList()"
    >
      <mat-icon svgIcon="trash"></mat-icon>
    </button>
  </div>
</div>
